import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import {
  AddCircle,
  DocumentDownload,
  Edit2,
  TickCircle,
  Trash,
} from "iconsax-react";
import { useSelector } from "react-redux";
import CustomPagination from "../../Utils/CustomPagination";
import { useLoader } from "../../Loader";

function List(props) {
  const [product, setProduct] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [sequenceUpdateQueue, setSequenceUpdateQueue] = useState({});
  const { startLoader, stopLoader } = useLoader();

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: (
        <div>
          Product Name <br />
        </div>
      ),
      selector: (row) => row.product_name,
      minWidth: "180px",
    },
    {
      name: (
        <div>
          Product Code <br />
        </div>
      ),
      selector: (row) => row.productCode,
    },
    {
      name: (
        <div>
          Product Category <br />
        </div>
      ),
      selector: (row) => row.productCategory,
    },
    {
      name: (
        <div>
          Regular Price <br />
        </div>
      ),
      selector: (row) => row.regularPrice,
    },
    {
      name: (
        <div>
          Sales Price <br />
        </div>
      ),
      selector: (row) => row.salesPrice,
    },
    {
      name: (
        <div>
          Artisan Coupon Value <br />
        </div>
      ),
      selector: (row) => row.couponValue,
    },
    {
      name: (
        <div>
          Non Scannable Coupon Value <br />
        </div>
      ),
      selector: (row) => row.nonScannableCouponValue,
      style: {
        //backgroundColor: "#f7f7f7",
      },
    },
    {
      name: (
        <div>
          Size <br />
        </div>
      ),
      selector: (row) => row.size + " " + (row?.unit || ""),
    },
    {
      name: (
        <div>
          Sequence <br />
        </div>
      ),
      selector: (row) => row.sequence || "",
      center: true,
      cell: (row) => {
        const currentInput = sequenceUpdateQueue[row.id];
        const originalValue = String(row.sort_order ?? "");
        const isValid =
          /^\d+$/.test(currentInput) && parseInt(currentInput, 10) > 0;
        const isChanged = isValid && currentInput !== originalValue;

        const handleChange = (e) => {
          const value = e.target.value;
          if (/^\d*$/.test(value)) {
            setSequenceUpdateQueue((prev) => ({
              ...prev,
              [row.id]: value,
            }));
          }
        };

        const handleSave = () => {
          startLoader();
          const formData = new FormData();
          formData.append("product_id", row.id);
          formData.append("reorder_no", parseInt(currentInput, 10));

          utils
            .callAPI("post", "/Product/re-order", formData)
            .then((res) => {
              getproduct(); // Refresh data
              setSequenceUpdateQueue((prev) => {
                const updated = { ...prev };
                delete updated[row.id];
                return updated;
              });
              stopLoader();
            })
            .catch((err) => {
              stopLoader();
              console.error("Failed to update sequence:", err);
              Swal.fire("Error", "Failed to update sequence", "error");
            });
        };

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={currentInput !== undefined ? currentInput : originalValue}
              onChange={handleChange}
              style={{ width: "40px" }}
            />
            {isChanged && (
              <span
                onClick={handleSave}
                style={{ cursor: "pointer" }}
                title="Update Sequence"
              >
                <TickCircle size="24" />
              </span>
            )}
          </div>
        );
      },
    },

    {
      name: "Action",
      center: true,
      style: {
        //  backgroundColor: "#f7f7f7",
      },
      cell: (row) => (
        <>
          {utils.hasPermission(primaryMenuRes, "Product", "product.edit") && (
            <RB.Button className="btn-flat" onClick={handelEdit(row)}>
              <Edit2 />
            </RB.Button>
          )}
          {utils.hasPermission(primaryMenuRes, "Product", "product.delete") && (
            <RB.Button className="btn-flat" btn-flat onClick={showDelete(row)}>
              <Trash />
            </RB.Button>
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    getproduct();
  }, [page, filterText]);

  const getproduct = () => {
    utils
      .callAPI(
        "get",
        `/Product/list?page=${page}&per_page=${countPerPage}&search=${filterText}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setProduct(res);
        } else {
          setProduct([]);
        }
      })
      .catch((err) => {
        setProduct([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `Product/delete?productId=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getproduct();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const handleDownload = () => {
    const csvEscape = (val) => {
      const s = String(val ?? "");
      return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };

    const getAlertQty = (alerts, wanted) => {
      if (!Array.isArray(alerts)) return "";
      const found = alerts.find(
        (a) => String(a.priority || "").toLowerCase() === wanted
      );
      return found?.unit ?? "";
    };

    const cleanCell = (val) => {
      if (!val) return "";
      return String(val)
        .replace(/\r?\n|\r/g, " ") // remove newlines
        .replace(/\s\s+/g, " ") // collapse multiple spaces
        .trim();
    };

    utils
      .callAPI(
        "get",
        `/Product/list?page=0&per_page=0&search=${encodeURIComponent(
          filterText
        )}`
      )
      .then((res) => {
        const rows = Array.isArray(res?.result) ? res.result : [];
        if (rows.length === 0) return;

        // Header EXACTLY as requested
        const header = [
          "Product Name",
          "Product Code",
          "Product Category",
          "Regular Price",
          "Sales Price",
          "Size",
          "Unit",
          "MOU",
          "Artisan Coupon Value",
          "Scannable Coupon Value",
          "Non Scannable Coupon Value",
          "Characteristics",
          "Usage guide",
          "Description",
          "HSN No",
          "SKU",
          "GST Info- SGST %",
          "CGST %",
          "IGST %",
          "STOCK ALERT- HIGH (Quantity)",
          "MEDIUM (Quantity)",
          "LOW (Quantity)",
        ];

        const csvRows = rows.map((item) => {
          const high = getAlertQty(item.stock_alert, "high");
          const medium = getAlertQty(item.stock_alert, "medium");
          const low = getAlertQty(item.stock_alert, "low");

          return [
            item.product_name, // Product Name
            item.productCode, // Product Code
            item.productCategoryName || item.productCategory || "", // Product Category
            item.regularPrice, // Regular Price
            item.salesPrice, // Sales Price
            item.size, // Size
            item.unit, // Unit
            item.mou, // MOU
            item.couponValue, // Artisan Coupon Value
            item.couponValue, // Scannable Coupon Value (same as couponValue)
            item.nonScannableCouponValue, // Non Scannable Coupon Value
            item.characteristics, // Characteristics
            item.usageGuide, // Usage guide
            item.description, // Description
            item.hsn_code, // HSN No
            item.sku_no, // SKU
            item.sgst, // SGST %
            item.cgst, // CGST %
            item.igst, // IGST %
            high, // STOCK ALERT- HIGH (Quantity)
            medium, // STOCK ALERT- MEDIUM (Quantity)
            low, // STOCK ALERT- LOW (Quantity)
          ]
            .map((v) => csvEscape(cleanCell(v)))

            .join(",");
        });

        const csv = [
          "\uFEFF" + header.map(csvEscape).join(","), // BOM for Excel
          ...csvRows,
        ].join("\n");

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Product_List.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error("Download error:", err);
      });
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow card-primary">
        <RB.CardHeader>
          <div className="floating-btns-holder-artisan">
            {utils.hasPermission(
              primaryMenuRes,
              "Product",
              "product.create"
            ) && (
              <a
                href
                className="btn btn-dark btn-circle"
                variant="dark"
                onClick={handleAddClick}
              >
                <AddCircle />
              </a>
            )}
            <a
              href
              className={`btn btn-primary btn-circle ms-2`}
              variant="primary"
              onClick={() => handleDownload()}
            >
              <DocumentDownload />
            </a>
          </div>
        </RB.CardHeader>

        <RB.Card.Body>
          {utils.hasPermission(primaryMenuRes, "Product", "product.view") && (
            <DataTable
              columns={columns}
              data={product.result}
              highlightOnHover
              responsive
              pagination
              striped
              paginationServer
              paginationTotalRows={product.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              paginationComponent={() => (
                <CustomPagination
                  currentPage={page}
                  totalRows={product.total}
                  rowsPerPage={countPerPage}
                  onPageChange={handlePageChange}
                />
              )}
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              //overflowX="auto"
              subHeader
              subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
